import i18n from "@i18n";

const { t } = i18n.global;

export default [
    {
        path: "service-lines",
        name: "service-lines",
        component: () => import("@views/admin/service_lines/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.service_lines_list"),
            action: "read",
            module: "ServiceLine",
        },
    },
    {
        path: "add-service-line",
        name: "add-service-line",
        component: () => import("@views/admin/service_lines/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_service_line"),
            action: "create",
            module: "ServiceLine",
        },
    },
    {
        path: "edit-service-line/:id(\\d+)",
        name: "edit-service-line",
        component: () => import("@views/admin/service_lines/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_service_line"),
            action: "update",
            module: "ServiceLine",
        },
    },

    {
        path: "offerings",
        name: "offerings",
        component: () => import("@views/admin/offerings/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.offerings_list"),
            action: "read",
            module: "Offering",
        },
    },
    {
        path: "add-offerings",
        name: "add-offerings",
        component: () => import("@views/admin/offerings/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_offerings"),
            action: "create",
            module: "Offering",
        },
    },
    {
        path: "edit-offerings/:id(\\d+)",
        name: "edit-offerings",
        component: () => import("@views/admin/offerings/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_offerings"),
            action: "update",
            module: "Offering",
        },
    },


    {
        path: "industry",
        name: "industry",
        component: () => import("@views/admin/industry/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.industry_list"),
            action: "read",
            module: "Industry",
        },
    },
    {
        path: "add-industry",
        name: "add-industry",
        component: () => import("@views/admin/industry/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_industry"),
            action: "create",
            module: "Industry",
        },
    },
    {
        path: "edit-industry/:id(\\d+)",
        name: "edit-industry",
        component: () => import("@views/admin/industry/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_industry"),
            action: "update",
            module: "Industry",
        },
    },


    {
        path: "digital-solutions",
        name: "digital-solutions",
        component: () => import("@views/admin/digitalSolution/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.digital_solution_list"),
            action: "read",
            module: "DigitalSolution",
        },
    },
    {
        path: "add-digital-solution",
        name: "add-digital-solution",
        component: () => import("@views/admin/digitalSolution/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_digital_solution"),
            action: "create",
            module: "DigitalSolution",
        },
    },
    {
        path: "edit-digital-solution/:id(\\d+)",
        name: "edit-digital-solution",
        component: () => import("@views/admin/digitalSolution/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_digital_solution"),
            action: "update",
            module: "DigitalSolution",
        },
    },

    {
        path: "managed-services",
        name: "managed-services",
        component: () => import("@views/admin/managedServices/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.managed_services_list"),
            action: "read",
            module: "ManagedService",
        },
    },
    {
        path: "add-managed-services",
        name: "add-managed-services",
        component: () => import("@views/admin/managedServices/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_managed_service"),
            action: "create",
            module: "ManagedService",
        },
    },
    {
        path: "edit-managed-services/:id(\\d+)",
        name: "edit-managed-services",
        component: () => import("@views/admin/managedServices/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_managed_service"),
            action: "update",
            module: "ManagedService",
        },
    },


    {
        path: "document-types",
        name: "document-types",
        component: () => import("@views/admin/documentTypes/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.document_types_list"),
            action: "read",
            module: "DocumentType",
        },
    },
    {
        path: "add-document-types",
        name: "add-document-types",
        component: () => import("@views/admin/documentTypes/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_document_types"),
            action: "create",
            module: "DocumentType",
        },
    },
    {
        path: "edit-document-types/:id(\\d+)",
        name: "edit-document-types",
        component: () => import("@views/admin/documentTypes/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_document_types"),
            action: "update",
            module: "DocumentType",
        },
    },
    {
        path: "sharebility",
        name: "sharebility",
        component: () => import("@views/admin/shareability/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.sharebility_list"),
            // action: "read",
            // module: "Client",
        },
    },
    {
        path: "clients",
        name: "clients",
        component: () => import("@views/admin/clients/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.clients_list"),
            action: "read",
            module: "Client",
        },
    },
    {
        path: "add-clients",
        name: "add-clients",
        component: () => import("@views/admin/clients/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_clients"),
            action: "create",
            module: "Client",
        },
    },
    {
        path: "edit-clients/:id(\\d+)",
        name: "edit-clients",
        component: () => import("@views/admin/clients/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_client"),
            action: "update",
            module: "Client",
        },
    },

    {
        path: "clients-types",
        name: "clients-types",
        component: () => import("@views/admin/clients_types/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.clients_types_list"),
            action: "read",
            module: "ClientType",
        },
    },
    {
        path: "add-clients-types",
        name: "add-clients-types",
        component: () => import("@views/admin/clients_types/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_clients_types"),
            action: "create",
            module: "ClientType",
        },
    },
    {
        path: "edit-clients-types/:id(\\d+)",
        name: "edit-clients-types",
        component: () => import("@views/admin/clients_types/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_clients_types"),
            action: "update",
            module: "ClientType",
        },
    },

    {
        path: "charge-codes",
        name: "charge-codes",
        component: () => import("@views/admin/charge_codes/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("fields.charge_codes_list"),
            action: "read",
            module: "ChargeCode",
        },
    },
    {
        path: "add-charge-codes",
        name: "add-charge-codes",
        component: () => import("@views/admin/charge_codes/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("fields.add_charge_codes"),
            action: "create",
            module: "ChargeCode",
        },
    },
    {
        path: "edit-charge-codes/:id(\\d+)",
        name: "edit-charge-codes",
        component: () => import("@views/admin/charge_codes/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("fields.edit_charge_codes"),
            action: "update",
            module: "ChargeCode",
        },
    },

    {
        path: "business-domains",
        name: "business-domains",
        component: () => import("@views/admin/business_domains/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.business_domains_list"),
            action: "read",
            module: "BusinessDomain",
        },
    },
    {
        path: "add-business-domains",
        name: "add-business-domains",
        component: () => import("@views/admin/business_domains/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_business_domains"),
            action: "create",
            module: "BusinessDomain",
        },
    },
    {
        path: "edit-business-domains/:id(\\d+)",
        name: "edit-business-domains",
        component: () => import("@views/admin/business_domains/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_business_domains"),
            action: "update",
            module: "BusinessDomain",
        },
    },
    /* {
        path: "business-units",
        name: "business-units",
        component: () => import("@views/admin/business_units/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.business_units_list"),
            action: "read",
            module: "BusinessUnit",
        },
    },
    {
        path: "add-business-units",
        name: "add-business-units",
        component: () => import("@views/admin/business_units/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_business_units"),
            action: "create",
            module: "BusinessUnit",
        },
    },
    {
        path: "edit-business-units/:id(\\d+)",
        name: "edit-business-units",
        component: () => import("@views/admin/business_units/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_business_units"),
            action: "update",
            module: "BusinessUnit",
        },
    }, */

    {
        path: "users",
        name: "users",
        component: () => import("@views/admin/users/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.users_list"),
            action: "read",
            module: "User",
        },
    },
    {
        path: "add-users",
        name: "add-users",
        component: () => import("@views/admin/users/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_user"),
            action: "create",
            module: "User",
        },
    },
    {
        path: "edit-users/:id(\\d+)",
        name: "edit-users",
        component: () => import("@views/admin/users/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_user"),
            action: "update",
            module: "User",
        },
    },

    {
        path: "designation",
        name: "roles",
        component: () => import("@views/admin/roles/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.roles_list"),
            action: "read",
            module: "Role",
        },
    },
    {
        path: "add-designation",
        name: "add-roles",
        component: () => import("@views/admin/roles/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_role"),
            action: "create",
            module: "Role",
        },
    },
    {
        path: "edit-designation/:id(\\d+)",
        name: "edit-roles",
        component: () => import("@views/admin/roles/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_role"),
            action: "update",
            module: "Role",
        },
    },
    {
        path: "approvals-members",
        name: "approvals-members",
        component: () => import("@views/admin/approvals_members/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.approvals_members"),
            action: "manage-project-approvals",
            module: "Setting",
        },
    },

    {
        path: "default-partners",
        name: "default-partners",
        component: () => import("@views/admin/defaultPartner/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.default_partners_list"),
            action: "read",
            module: "DefaultPartner",
        },
    },
    {
        path: "add-default-partners",
        name: "add-default-partners",
        component: () => import("@views/admin/defaultPartner/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.add_default_partners"),
            action: "create",
            module: "DefaultPartner",
        },
    },
    {
        path: "edit-default-partners/:id(\\d+)",
        name: "edit-default-partners",
        component: () => import("@views/admin/defaultPartner/Create.vue"),
        meta: {
            requiresAuth: true,
            title: t("messages.edit_default_partners"),
            action: "update",
            module: "DefaultPartner",
        },
    },


];
